import { Injectable } from '@angular/core';
import { ApiAutoCompleteService, FieldSelectOption } from 'components/shared';

import { Observable } from 'rxjs';
import { filter, map, shareReplay } from 'rxjs/operators';

import { CodeWrapperService } from '../service-wrappers/code-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class RemarkCodesLookupService extends ApiAutoCompleteService {
  constructor(private service: CodeWrapperService) {
    super();
  }

  existingValues: string[] = [];

  mapRow(result) {
    return {
      value: result,
      label: `${result.code} - ${result.name}`,
      shortLabel: result.code,
      inactive: result.inactive,
      name: result.name,
      suppressSecondary: result.suppressSecondary,
      isWriteOffProc: result.writeoffRemainder,
      isDenial: result.isDenial
    };
  }

  search(value: string): Observable<FieldSelectOption[]> {
    return this.service
      .apiV1CodeCodetypePost('RemarkCode', { generalSearch: value, pageSize: 9999 })
      .pipe(map((results) => results.data.map(this.mapRow).filter((x: any) => (!x.inactive || this.existingValues.includes(x.value)))));
  }
}
